export default {
  max: 1168,
  min: 320
}
